import React, { Component } from "react";
import { connect } from 'react-redux';
import ThemeModal from 'components/ThemeComponents/ThemeModal';
import OpenModalButton from 'components/ThemeComponents/openModelButton';
import {
  Grid,
  Row,
  Col,

  Tooltip,
  OverlayTrigger,
  Button
} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import { emailTemplatesActions } from 'redux/actions/email-templates-action';
import { Table } from "react-bootstrap";
import EmailTemplateForm from "./EmailTemplateForm";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
var Modal = require('react-bootstrap-modal');

class EmailTemplatesListingPage extends Component {
	constructor(props){
    	super(props);
    	this.state = {
    		addModalEmailTemp  : false,
    		editModalEmailTemp  : false,
      		editEmailTemplateObject  : null,
			showTemplateVariables: false,
    	}
    	this.openModalEmailTemp 		= this.openModalEmailTemp.bind(this);
    	this.closeModalEmailTemp 		= this.closeModalEmailTemp.bind(this);
    	this.openModalEmailTempEdit 	= this.openModalEmailTempEdit.bind(this);
    	this.closeModalEmailTempEdit 	= this.closeModalEmailTempEdit.bind(this);
    	this.handleEmailTempSubmit  	= this.handleEmailTempSubmit.bind(this);
    	this.deleteEmailTemp            = this.deleteEmailTemp.bind(this);
    	this.deleteConfirmEmailTemp     = this.deleteConfirmEmailTemp.bind(this);
    	this.props.getEmailTemplatesCall();
    	this.props.getMailTypesCall();
	}

	openModalEmailTemp(){
    	this.setState({addModalEmailTemp:true});
  	}
  	closeModalEmailTemp(){
  		this.setState({addModalEmailTemp:false});	
  	}
  	openModalEmailTempEdit(key){
  		this.setState({editEmailTemplateObject:this.props.emailTemplatesList[key]}, function(){
  			this.setState({editModalEmailTemp:true});	
  		});
  	}
	
	openModal(name) {
	this.setState({
		[name]: true
	});
	}
	toggleModal(name) {
	this.setState({
		[name]: !this.state[name]
	});
	}
  	closeModalEmailTempEdit(){
  		this.setState({editEmailTemplateObject:null}, function(){
  			this.setState({editModalEmailTemp:false});	
  		});
  	}

  	handleEmailTempSubmit(data, formType){
  		if (formType === 'create') {
			this.props.storeEmailTemplatesCall(data).then(response => {
				this.setState({'addModalEmailTemp' : false}, function(){
					this.props.getEmailTemplatesCall();
				})
			}, error=> {

			});
  		} else if ( formType === 'edit') {
  			this.props.editEmailTemplatesCall(data, data.id).then(response => {
				this.setState({'editModalEmailTemp' : false}, function(){
					this.props.getEmailTemplatesCall();
				})
			}, error=> {

			});
  		}
  	}
  	deleteEmailTemp(tempId){
  		this.props.deleteEmailTemplatesCall(tempId).then(response=>{
  			this.props.getEmailTemplatesCall();
  		});
  	}
  	deleteConfirmEmailTemp(tempId){
  		confirmAlert({
      		customUI: ({ onClose }) => {
        		return (
          			<div className='custom-ui'>
	            		<div className="react-confirm-alert-body">
			          		<h3>Delete Email Template</h3>
			          		<p className="marginFromTopPopUp" >Are you sure to delete the email template?</p>
			          		<div className="react-confirm-alert-button-group">
				                <button onClick={onClose}>No</button>
				                <button onClick={() => {
				                    	this.deleteEmailTemp(tempId)
				                    	onClose()
				                	}}>Yes
				               	</button>
			          		</div>
	            		</div> 
          			</div>
        		)
      		}
    	})
    }

	render(){
		const { emailTemplatesList, emailTypes } = this.props;
		const { editModalEmailTemp, editEmailTemplateObject, addModalEmailTemp } = this.state;
		return(
			<div className="content">
        		<Grid fluid>
            		<Row>
            			<Col md={12}>
	              			<Card
	                  			title="Email Templates List"
	                  			ctTableResponsive
	                  			tooltiptext="You can create email templates for music directors and adjudicators from here. You can also mark any email as default so when the company admin will send emails, the default one will load and the admin can still select a different template before sending an email."
	                  			content={
	                  				<div>
	                  					<Grid fluid>
					                        <Row>
					                            <Col md={2} sm={6} xs={12}>
					                            	<div>
					                                	<OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Add Email Template</Tooltip>}>
					                                  		<Button type='button' className="outOfTableButton btn btn-info" onClick={this.openModalEmailTemp} ><i className="fa fa-plus" />Email Template</Button>
					                                	</OverlayTrigger>
					                              	</div>
					                            </Col>
					                        </Row>
					                    </Grid>
		                  				<Table striped hover className="myTable">
								            <thead>
								            	<tr>
								              		<th>Subject</th>
								                	<th>Email Type</th>
								                	<th>Default</th>
								                	<th className="text-center">Edit</th>
								               	</tr>
								            </thead>
								            <tbody>
								            	{
								            		emailTemplatesList.map((prop, key) => {
								                		return (
							                				<tr key={ key }>
							                					<td>{ prop.subject }</td>
							                					<td>{ prop.mail_templates_type.name }</td>
							                					<td>{ prop.default ? 'Yes' : 'No' }</td>
								                				<td className="text-center">
								                					<OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Edit Email Template</Tooltip>}>
								                						<Button className="action-button-size"  onClick={()=>this.openModalEmailTempEdit(key)}><i className="fa fa-pencil" /></Button>
								                					</OverlayTrigger>
								                					<OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Delete Email Template</Tooltip>}>
								                						<Button className="action-button-size"  onClick={()=>this.deleteConfirmEmailTemp(prop.id)}><i className="fa fa-trash " /></Button>
								                					</OverlayTrigger>
								                				</td>
								                			</tr>
								                		);
								            		})
								            	
								            	}
								            </tbody>
								        </Table>
							        </div>
	                  			}
	                  		/>
            			</Col>
           			</Row>
        		</Grid>
        		{/*Add Email Template Start*/}
	            	<Modal show={addModalEmailTemp} onHide={this.closeModalEmailTemp} aria-labelledby="ModalHeader" >
		                <Modal.Header closeButton>
		                	<Modal.Title id='ModalHeader'>
								<span>Add Email Templates</span>
								<OpenModalButton
                                    openModal={() => {this.openModal("showTemplateVariables")}}
                                    classButton={['backButton pt-sm no_radius pb-sm primary mt-none btn-info btn btn-sm btn-rt']}
                                    buttonName="Show Variables"
                                    tooltipText={'Show Variables'}
                                    classIcon={[]}
                                    style={{marginRight: 15, float:'right'}}
                                  />
							</Modal.Title>
		                </Modal.Header>
	                	<Modal.Body>
	                  		<div className="row">
	                    		<div className="col-md-12">
	                      			<EmailTemplateForm emailTemplate= {{
		                      				subject: '' ,
							    			html_template: '',
							    			mail_templates_id:  null,
							    			default:0, 
							    			testEmail:''

		                      			}}
	                      				mailTypes={emailTypes}
	                      				formType='create'
	                      				handleEmailTempSubmit = { this.handleEmailTempSubmit }
	                      				buttonName="Save"
	                      			/>
	                    		</div>
	                  		</div>
	                	</Modal.Body>
	              	</Modal>
	            {/*Add Email Template End*/}

	            {/*Edit Email Template Start*/}
	            {
	            	editEmailTemplateObject &&
	            	<Modal show={editModalEmailTemp } onHide={this.closeModalEmailTempEdit} aria-labelledby="ModalHeader" >
		                <Modal.Header closeButton>
		                	<Modal.Title id='ModalHeader'>
								<span>Edit Email Templates</span>
                        		<OpenModalButton
                                    openModal={() => {this.openModal("showTemplateVariables")}}
                                    classButton={['backButton pt-sm no_radius pb-sm primary mt-none btn-info btn btn-sm btn-rt']}
                                    buttonName="Show Variables"
                                    tooltipText={'Show Variables'}
                                    classIcon={[]}
                                    style={{marginRight: 15, float:'right'}}
                                  />
							</Modal.Title>
		                </Modal.Header>
	                	<Modal.Body>
	                  		<div className="row">
	                    		<div className="col-md-12">
	                      			<EmailTemplateForm 
	                      				emailTemplate= {{...editEmailTemplateObject, testEmail:''}}
	                      				mailTypes={emailTypes}
	                      				formType='edit'
	                      				handleEmailTempSubmit = { this.handleEmailTempSubmit }
	                      				buttonName="Update"
	                      			/>
	                    		</div>
	                  		</div>
	                	</Modal.Body>
	              	</Modal>
	            }
	            {/*Edit Email Template End*/}
				<ThemeModal modalClass='' title='Variables' show={this.state.showTemplateVariables} hide={() => {
                      this.toggleModal('showTemplateVariables')
                    }}>
                      <ul>
                        <li><strong>{"{{FestivalName}}"}</strong> : Festival Name</li>
                        <li><strong>{"{{FestivalUserName}}"}</strong> : Festival User Name who is logged in the admin</li>
                        <li><strong>{"{{FestivaldateStart}}"}</strong> : Festival Start Date</li>
                        <li><strong>{"{{FestivaldateEnd}}"}</strong> : Festival End Date</li>
                        <li><strong>{"{{FestivalStartDate}}"}</strong> : Festival Start Date</li>
                        <li><strong>{"{{FestivalEndDate}}"}</strong> : Festival End Date</li>
                        {/* <li><strong>{"{{UserName}}"}</strong> : In case of music director it will be name, and in case of adjudicator it will be first name + last name</li> */}
                        <li><strong>{"{{CompanyName}}"}</strong> : Company Name</li>
                        <li><strong>{"{{PrimaryContactName}}"}</strong> : Primary Contact Name</li>
                        <li><strong>{"{{AdjudicatorCode}}"}</strong> : Music Adjudicator Code</li>
                        <li><strong>{"{{MusicDirectorUserName}}"}</strong> : Music Director Username</li>
                        <li><strong>{"{{AdjudicatorName}}"}</strong> : Music Adjudicator Name</li>
                        <li><strong>{"{{MusicDirectorName}}"}</strong> : Music Director Name</li>
                        <li><strong>{"{{DirectorGroupName}}"}</strong> : Music Director Group Name</li>
                        <li><strong>{"{{DirectorSchoolName}}"}</strong> : Music Director School Name</li>
                      </ul>
                    </ThemeModal>
        	</div>
		);
	};
}

const mapDispatchToProps = dispatch => {
  return ({
    getEmailTemplatesCall: () => { dispatch(emailTemplatesActions.getEmailTemplates()) },
    getMailTypesCall: () => { dispatch(emailTemplatesActions.getMailTypes()) },
    storeEmailTemplatesCall: (data) => { return dispatch(emailTemplatesActions.storeEmailTemplates(data)) },
    editEmailTemplatesCall: (data, id) => { return dispatch(emailTemplatesActions.editEmailTemplates(data, id)) },
    deleteEmailTemplatesCall: (id) => { return dispatch(emailTemplatesActions.deleteEmailTemplates(id)) },
  });
};

function mapStateToProps(state) {
    const { loading, emailTemplatesList, emailTypes } = state.emailTemplateReducer;

    return {
        loading, emailTemplatesList, emailTypes
    };
}

const EmailTemplatesListing = connect(mapStateToProps, mapDispatchToProps)(EmailTemplatesListingPage);


export default EmailTemplatesListing;



// WEBPACK FOOTER //
// ./src/components/Admin/EmailTemplates/EmailTemplatesListing.jsx